import { Stack, Checkbox } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

import { Box } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const Container = muiStyled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: 1,
  overflow: 'hidden',
  background: abyssColors.primary[50],
});

export const Header = muiStyled(Box)({
  padding: '1.6rem 1.2rem',
  display: 'flex',
  alignItems: 'center',
  marginTop: '1rem',
});

export const Footer = muiStyled(Box)({
  padding: '2.4rem 1.6rem',
  background: abyssColors.neutral[50],
  boxShadow: '0px -3px 4px 0px rgba(0, 0, 0, 0.05)',
});

export const StyledCheckbox = muiStyled(Checkbox)(
  ({ highlighted = false }: { highlighted?: boolean }) => ({
    color: highlighted ? abyssColors.primary[100] : abyssColors.primary[700],
    padding: 0,
    margin: 0,
    '&.Mui-checked': {
      color: highlighted ? abyssColors.primary[100] : abyssColors.primary[700],
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.8rem',
      marginRight: '0.8rem',
    },
  })
);
